import { isSwimmingSchool } from "../../../../../utils/TicketPassHelper";
import { Ticket } from "../../../../../models/Ticket";

export interface CatchUpLessonsTicketInfo {
  ticket: Ticket;
  count: number;
}

/** Tymczasowy sztywniak: pełny zestaw terminów na karnecie szkółki. */
const EXPECTED_SWIMMING_SCHOOL_TERMS = 17;

/**
 * Lekcje do odrobienia = brakujące terminy względem 17 exercises na karnecie.
 * 17 zapisanych → belka znika (klient już wybrał komplet, w tym odrobienia).
 * Mniej niż 17 → belka z różnicą.
 * Sztywniak, dopóki API nie da prawdziwego licznika odrobić. Tylko passtype 9.
 */
export default function getCatchUpLessonsTickets(tickets: Ticket[]): CatchUpLessonsTicketInfo[] {
  return tickets
    .filter((ticket) => isSwimmingSchool(ticket.passtype))
    .map((ticket) => ({
      ticket,
      count: Math.max(0, EXPECTED_SWIMMING_SCHOOL_TERMS - (ticket.exercises?.length || 0)),
    }))
    .filter((info) => info.count > 0);
}
